import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AfterViewInit, Component, forwardRef, Inject, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SessionService} from '../../services/session.service';
import {AvailableJobAggregation, JobAndUnitInfo, MaskFormats, ModalResult, Unit} from '../../model/common.model';
import {EmployeeInfo} from "../../model/schedule.model";
import {TreeHelper, UnitTreeItem} from "../../model/tree.model";

import {AlertService} from "../../services/alert.service";
import {RetrieveDateFromUI} from "../../directives/retrieveDateFromUI";
import {MemoAggregation, MemoEmployee} from "./model/MemoAggregation";
import {ClientService} from "../../services/client.service";
import {JSonSerializer} from "../../model/JSonSerializer";
import * as moment from 'moment';
import {MyTreeViewForUnitI18n} from "../../i18n/TreeView.languages";
import {DisplayInterval} from "../../directives/displayInterval";
import {ValidateStartEndTimeIntervalDirective} from "../../directives/ValidateStartEndTimeIntervalDirective";
import {MemoContentWorkShift} from "./model/MemoContentWorkShift";
import {CustomMemoAggregation} from "./model/CustomMemoAggregation";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

import {DlgErrorMessage} from "../../common/DlgErrorMessage";
import {Utils} from "../../model/Utils";
import {TreeviewI18n} from "../../common/components/tree/models/treeview-i18n";
import {TreeviewConfig} from "../../common/components/tree/models/treeview-config";
import {TreeviewItem} from "../../common/components/tree/models/treeview-item";
import {IMultiSelectItem} from "../../common/components/select/IMultiSelectItem";

@Component({
  templateUrl: 'DlgWorkShiftRequestComponent.html',
  providers: [
    { provide: TreeviewI18n, useClass: MyTreeViewForUnitI18n }
  ]
})
export class DlgWorkShiftRequestComponent implements AfterViewInit{
  @Input() loading = false;
  // recipients = new Array<Selected<EmployeeInfo>>();
  divisions: Unit[];
  services: Unit[];
  departments: Unit[];
  subDepartments: Unit[];
  private _availableJobAggregation: AvailableJobAggregation;

  // For Jobs
  treeRoot: UnitTreeItem;
  @Input() treeviewConfig = new TreeviewConfig();
  @Input() treeviewItems: TreeviewItem[] = [];
  selectedUnitIds = new Array<string>();
  jobs = new Array<JobAndUnitInfo>();


  //For Recipients
  treeRoot2: UnitTreeItem;
  @Input() treeviewConfig2 = new TreeviewConfig();
  @Input() treeviewItems2: TreeviewItem[] = [];
  selectedUnitIds2 = new Array<string>();

  retrieveDate = new RetrieveDateFromUI();



  data: MemoAggregation;
  content: MemoContentWorkShift;


  private memoEmployeeById = new Map<string,MemoEmployee>();

  optionsModel = new Array<string>();
  myRecipients = new Array<IMultiSelectItem>();
  /*
  mySettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'checkboxes',
    // buttonClasses: 'btn btn-default btn-block',
    // buttonClasses: 'btn btn-default',
    buttonClasses: 'btn btn-nothing',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true
  };

  myTexts: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    // searchPlaceholder: 'Find',
    searchEmptyResult: 'Nothing found...',
    // searchNoRenderText: 'Type in search box to see results...',
    defaultTitle: 'Select Recipients',
    allSelected: 'All selected',
  };

  myTextsFr: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'récipient',
    checkedPlural: 'récipients',
    // searchPlaceholder: 'Find',
    searchEmptyResult: 'Aucune sélection...',
    // searchNoRenderText: 'Type in search box to see results...',
    defaultTitle: 'Sélectionner les destinaires',
    allSelected: 'Tout est sélectionné',
  };
  */
  startEndWorkshiftTimeStr: string;

  hourMinuteMask:(string | RegExp)[];
  maskStartEndTime: (string | RegExp)[];
  displayInterval: DisplayInterval;
  formatAMPM = false;

  includeInactivePosition = false;



  constructor(public activeModal: NgbActiveModal,
              @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
              @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
              @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => NgbModal)) protected modalService: NgbModal,
              @Inject(forwardRef(() => SessionService)) private session: SessionService,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {

    this._init();
  }

  private _init(){

      this.alertService.clear();
      this.loading = true;
      // this.loadAllUsers();
      this.divisions = this.session.unitManager.getOrderedUnitByType('DIVISION');
      this.services = this.session.unitManager.getOrderedUnitByType('SERVICE');
      this.departments = this.session.unitManager.getOrderedUnitByType('DEPARTEMENT');
      this.subDepartments = this.session.unitManager.getOrderedUnitByType('SOUS_DEPARTEMENT');
      this.treeRoot = TreeHelper.loadTree(this.divisions, this.session);
      this.treeviewItems = [new TreeviewItem(this.treeRoot)];

      this.treeRoot2 = TreeHelper.loadTree(this.divisions, this.session);
    this.treeviewItems2 = [new TreeviewItem(this.treeRoot2)];


   // console.log('currentLang: ' + this.translate.currentLang);
      this.maskStartEndTime = MaskFormats.INTERVAL_HOUR_FORMAT_24_5_MINUTES;
      this.hourMinuteMask = MaskFormats.HOUR_FORMAT_24_5_MINUTES;
      // if ('fr-CA' === this.translate.currentLang){
      //   this.myTexts = this.myTextsFr;
      // }

    if (this.session.userInfo.isAMPM()) {
      this.formatAMPM = true;
      this.maskStartEndTime = MaskFormats.INTERVAL_HOUR_FORMAT_AM_PM;
      this.hourMinuteMask = MaskFormats.HOUR_FORMAT_AM_PM
    }
    this.displayInterval = new DisplayInterval(this.session);

    this.loading = false;



  }


  changeActiveInactivePosition(){
    console.log('includeInactivePosition: ' + this.includeInactivePosition)
    this._refreshRecipientList();
  }


  selectAll(){

    this.optionsModel = new Array<string>();
    for (const emp of Array.from(this.memoEmployeeById.values())){
      this.optionsModel.push(emp.employeeCode);
    }

  }

  unSelectAll(){

    this.optionsModel = new Array<string>();
  }


  isItANewWorkshiftRequest(): boolean{
    if (this.content && this.content.applicantEmployeeCode){
      return false;
    }
    return true;
  }

  onSelectedChange($event) {
    // this.selectedUnitIds = new Array<string>();
    console.log('Selection changed. ' + $event + ' ' + (typeof $event),$event);
    this.jobs = new Array<JobAndUnitInfo>();
    let found = false;
    const mapToKeepTrackOfJob = new Map<string, string>();
    for (const id of $event) {
       console.log('checking id: ' + id);
      for (const availableJob of this._availableJobAggregation.availableJobWithUnit){
         // console.log('job.unit.unitCode: ' + availableJob.unit.unitCode);
        if (
          (availableJob.unit.unitCode === id) ||
          (availableJob.unit.parentCode === id) ||
          (availableJob.unit.rootCode === id) ){
          if (!mapToKeepTrackOfJob.get(availableJob.job.jobId)){
            mapToKeepTrackOfJob.set(availableJob.job.jobId,availableJob.job.jobId);
             console.log('adding Available Job ' + availableJob.job.jobId + ', ' + availableJob.job.description);

            if (availableJob.job.jobId === this.content.jobId){
               console.log('Job has been found.');
              found = true;
            }
            this.jobs.push(availableJob);
          }
        }
      }
      // this.selectedUnitIds.push(id);
    }
    this.jobs.sort(
      (a: JobAndUnitInfo, b: JobAndUnitInfo) =>  {
        let resN = 0;
        if (a.job.description.toLowerCase() > b.job.description.toLowerCase()) {
          resN = 1;
        }
        if (a.job.description.toLowerCase() < b.job.description.toLowerCase())  {
          resN = -1;
        }
        return resN;
      });
    if (!found){
      //
      // if the job can be found ( aka loading the job from an already saved record.)
      //
      console.log('The Job ' + this.content.jobId + " was not found. Resetting it.");
      this.content.jobId = null;
    }
  }


  onSelectedChange2($event) {
   // console.log('Selection2 changed. ' + $event + ' ' + (typeof $event));

    this.selectedUnitIds2 = new Array<string>();
    for (const id of $event) {
      this.selectedUnitIds2.push(id);
    }

    this._refreshRecipientList();
  }

  private _refreshRecipientList(){

   // console.log('_refreshRecipientList ' + this.content.jobId + ' units: ',this.selectedUnitIds2);

    if (this.selectedUnitIds2 && this.selectedUnitIds2.length>0){
      if (Utils.isEmpty(this.content.jobId)){
        this._retrieveEmployees(this.selectedUnitIds2);
      }else{
        this._retrieveEmployeesByUnitAndJob([this.content.jobId], this.selectedUnitIds2);
      }
      // this._retrieveEmployees(this.selectedUnitIds2);
    }else if (Utils.isEmpty(this.content.jobId)){
      /**
       * Request CGI Oct 11st 2024
       */
      console.log('Removed all recipients');
      this.myRecipients = new Array<IMultiSelectItem>();
      this.unSelectAll();
    }else{
      console.log('Load all recipients with the position ');
      this._retrieveEmployeesByUnitAndJob([this.content.jobId], []);
    }
  }

  onJobChange(){

    this._refreshRecipientList();
  }

  private _retrieveEmployeesByUnitAndJob(jobIds: string[], unitIds: string[]) {
    this.loading = true;
    this.alertService.clear();
    this.clientService.getAllActiveEmployeeWithJobAndUnit(jobIds, unitIds,this.session.canSendMemoToSameLevelUser,this.includeInactivePosition).then(
      (res) => {
        if (res.success) {
          this.myRecipients = new Array<IMultiSelectItem>();
          this.optionsModel = new Array<string>();
          // console.log('_allEmloyees is ' + JSON.stringify(res.data, null, 1));
          const serializer = new JSonSerializer();
          // this.recipients = new Array<Selected<EmployeeInfo>>();
          for (const b of res.data){
            const tmp = new EmployeeInfo();
            serializer.deserialize(b,tmp);

            const mm = new MemoEmployee();
            mm.employeeCode = tmp.id;
            mm.employeeFullName = tmp.fullName;
            this.memoEmployeeById.set(mm.employeeCode,mm);
            this.myRecipients.push({id:tmp.id,name: tmp.fullName});
            // this.recipients.push(new Selected<EmployeeInfo>(tmp,false));
          }

          //Verify that if Any
          for (const me of this.data.recipients){
            if (this.memoEmployeeById.has(me.employeeCode)){
              this.optionsModel.push(me.employeeCode);
            }else{
              this.memoEmployeeById.set(me.employeeCode, me);
              this.myRecipients.push({id:me.employeeCode, name: me.employeeFullName + ' *'});
              this.optionsModel.push(me.employeeCode);
            }
          }



        } else {
          console.log('Error ' + res.description + ' ' + res.data);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );
  }


  private _retrieveEmployees(unitIds: string[]) {
    this.loading = true;
    this.alertService.clear();
    this.clientService.getAllActiveEmployeePerUnitAction(unitIds,this.session.canSendMemoToSameLevelUser,this.includeInactivePosition).then(
      (res) => {
        if (res.success) {
          this.myRecipients = new Array<IMultiSelectItem>();
          this.optionsModel = new Array<string>();
          // console.log('_allEmloyees is ' + JSON.stringify(res.data, null, 1));
          const serializer = new JSonSerializer();
          // this.recipients = new Array<Selected<EmployeeInfo>>();
          for (const b of res.data){
            const tmp = new EmployeeInfo();
            serializer.deserialize(b,tmp);

            const mm = new MemoEmployee();
            mm.employeeCode = tmp.id;
            mm.employeeFullName = tmp.fullName;
            this.memoEmployeeById.set(mm.employeeCode,mm);
            this.myRecipients.push({id:tmp.id,name: tmp.fullName});
            // this.recipients.push(new Selected<EmployeeInfo>(tmp,false));
          }

          //Verify that if Any
           for (const me of this.data.recipients){
             if (this.memoEmployeeById.has(me.employeeCode)){
               this.optionsModel.push(me.employeeCode);
             }else{
               this.memoEmployeeById.set(me.employeeCode, me);
               this.myRecipients.push({id:me.employeeCode, name: me.employeeFullName + ' *'});
               this.optionsModel.push(me.employeeCode);
             }
           }



        } else {
          console.log('Error ' + res.description + ' ' + res.data);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );
  }

  private _toViewInitialize: MemoContentWorkShift;

  ngAfterViewInit(){
    console.log('NgAfterViewInit ');
    // this.content.unitId = this._toViewInitialize.unitId;
    // this.content.jobId = this._toViewInitialize.jobId;
    // this.onSelectedChange([this.content.unitId]);
    // this.onSelectedChange2([this.content.unitId]);
  }

  populate(memoAggregation: MemoAggregation, availableJobAggregation: AvailableJobAggregation, contenu?: MemoContentWorkShift) {
    this.data = memoAggregation;
    this._availableJobAggregation = availableJobAggregation;
    if (contenu){
      this.content = contenu;
      this._toViewInitialize = contenu.clone();
      // this.startEndWorkshiftTimeStr = this.displayInterval.display(this.content.interval,this.formatAMPM);
      this.startEndWorkshiftTimeStr = this.displayInterval.displayDates(this.content.startHour,this.content.endHour,this.formatAMPM);
      if (this.content.unitId){
        this.treeRoot = TreeHelper.loadTreeWithSelectedIds(this.divisions, this.session,this.content.unitId);
        this.treeviewItems = [new TreeviewItem(this.treeRoot)];

        this.treeRoot2 = TreeHelper.loadTreeWithSelectedIds(this.divisions, this.session,this.content.unitId);
        this.treeviewItems2 = [new TreeviewItem(this.treeRoot2)];

        // this.onSelectedChange([this.content.unitId]);
        // this.onSelectedChange2([this.content.unitId]);
        console.log("unitId: " + this.content.unitId + ', ' + this.content.unitLabel + ' jobId: ' + this.content.jobId + ' ' + this.content.jobLabel)
        this.onSelectedChange([this.content.unitId]);
        this.onSelectedChange2([this.content.unitId]);
      }
    }else{
      this.content = new MemoContentWorkShift();
    }

  }

  isFormValid(): boolean{
    if (this.optionsModel){
      if (this.optionsModel.length>0){
        return true;
      }
    }
    return false;
  }


  private _retrieveJobLabel(jobId: string): string {
    for (const availableJob of this._availableJobAggregation.availableJobWithUnit) {
      if (availableJob.job.jobId === jobId) {
        return availableJob.job.description ;
        // + '|' + availableJob.job.description;
      }
    }
    return null;
  }



  private _retrieveUnitForJob(jobId: string): Unit[] {
    const res = new Array<Unit>();
    for (const availableJob of this._availableJobAggregation.availableJobWithUnit) {
      if (availableJob.job.jobId === jobId) {
        res.push(availableJob.unit);
      }
    }
    return res;
  }

  /*
  private _retrieveUnitLabel(unitId: string): string {
    for (const availableJob of this._availableJobAggregation.availableJobWithUnit) {
      if (availableJob.unit.unitCode === unitId) {
        return availableJob.unit.description;
        // + '|' + availableJob.job.description;
      }
    }
    return null;
  }
  */


  onSave() {

    // this.startEndLunchTimeStr = this.displayInterval.displayDates(editing.meal1.start, editing.meal1.end,this.formatAMPM);

    this._retrieveStartEndTime(this.startEndWorkshiftTimeStr,this.content);
    this.content.jobLabel = this._retrieveJobLabel(this.content.jobId);
    const unitsForThisJob = this._retrieveUnitForJob(this.content.jobId);
    if (unitsForThisJob.length!=1){
      console.log('Found ' + unitsForThisJob.length + " units for the job: " + this.content.jobId + "/ " + this.content.jobLabel + ', well it goes against the normal way of doing thing in Emprez.');
      let _units = this.translate.instant('NoUnitFound');
      if (unitsForThisJob.length > 0){
        _units = '';

        for (const u of unitsForThisJob){
          if (_units.length>0){
            _units +=', ';
          }
          _units += u.description;
        }
      }
      const modalRef = this.modalService.open(DlgErrorMessage);
      this.alertService.registerModal(modalRef);
      modalRef.componentInstance.populate(this.translate.instant('Error'),this.translate.instant('StructureErrorJobInTooManyUnit',{job:  this.content.jobId + "/ " + this.content.jobLabel, units: _units }));
      modalRef.result.then((result) => {
      });


      return;
    }
    this.content.unitId = unitsForThisJob[0].unitCode;
    this.content.unitLabel = unitsForThisJob[0].description;

    if (Utils.isNullOrUndefined(unitsForThisJob[0].rootCode)){
      this.content.divisionId = unitsForThisJob[0].unitCode;
    }else{
      this.content.divisionId = unitsForThisJob[0].rootCode;
    }
    this.content.divisionLabel = this.session.getDivisionName(unitsForThisJob[0]);

    // this.content.unitLabel = this._retrieveUnitLabel(this.content.unitId);
    this.content.providerEmployeeCode = this.session.userInfo.user.employeeCode;

    console.log('to send: ' + JSON.stringify(this.content,null,2));
    // this.data.


    console.log('Destinataires: ' + this.optionsModel.length);

    // this.data.info.title =
    this.data.recipients = new Array<MemoEmployee>();

    for (const id of this.optionsModel){
      const me = new MemoEmployee();
      me.employeeCode = id;
      me.employeeFullName = this.memoEmployeeById.get(id).employeeFullName;
      console.log('Destinataire: ' + JSON.stringify(me));
      this.data.recipients.push(me)
    }
    this.loading = true;
    this.alertService.clear();
    const bean = new CustomMemoAggregation<MemoContentWorkShift>();
    bean.content = this.content;
    bean.memoAggregation = this.data;
    this.clientService.sendWorkShiftRequest(bean).then(
      (res) => {
        if (res.success) {
          console.log('Saved!');
          this.activeModal.close(ModalResult.OK);
        } else {
          console.log('Error ' + res.description + ' ' + res.data);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );


     /*
    */

  }

  onCancel() {
    this.activeModal.close(ModalResult.CANCEL);
  }

  _retrieveStartEndTime(value: string, bean: MemoContentWorkShift){
    const parser = new ValidateStartEndTimeIntervalDirective(this.translate);
    if (!parser.validateString(value)) {
      const timing = parser.retrieveDateTime(value);
      const startTime = timing[0];
      const endTime = timing[1];
      bean.startHour = moment().startOf('day').hour(startTime.h).minute(startTime.m).toDate();
      bean.endHour = moment().startOf('day').hour(endTime.h).minute(endTime.m).toDate();

      if (Utils.isAfterRefDate(bean.startHour,bean.endHour)){
        // Overnight
        bean.startHour = Utils.mixDateAndHourMinute(bean.eventDate,bean.startHour);
        bean.endHour = Utils.mixDateAndHourMinute(bean.eventDate,bean.endHour);
        bean.endHour = moment(bean.endHour).add(1,'day').toDate();
      }else{
        bean.startHour = Utils.mixDateAndHourMinute(bean.eventDate,bean.startHour);
        bean.endHour = Utils.mixDateAndHourMinute(bean.eventDate,bean.endHour);
      }

      console.log('Dates have been adjusted, ref: ' + bean.eventDate + ' start: ' + bean.startHour + ' end: ' + bean.endHour);

      // const de = new DateEncoding();
      // bean.interval = de.encodeWithOvernightCheck(startTime, endTime).interval;
      // bean.intervalOverNight = de.encodeWithOvernightCheck(startTime, endTime).intervalOverNight;
    }else{
      console.log('Workshift Parsing ' + value + ' is not possible.');
    }
  }

  explainApplication(memoAggregation: MemoAggregation, application: MemoContentWorkShift):SafeHtml{
    const di = new DisplayInterval(this.session);
    const res =  this.translate.instant('EmployeeAppliedOnWorkshiftRequest',
      {job: application.jobLabel,
        unit: application.unitLabel,
        employee: memoAggregation.info.fromName,
        eventDt: moment(application.eventDate).format('LL'),
        // schedule:  di.transform(application.interval),
        schedule:  di.displayDates(application.startHour,application.endHour,di.formatAMPM),
        note: application.note});
    return this.domSanitizer.bypassSecurityTrustHtml(res);


  }

  onReject(){
    const bean = new CustomMemoAggregation<MemoContentWorkShift>();
    bean.content = this.content;
    bean.memoAggregation = this.data;

    this.clientService.refuseAnApplicationToAWorkShiftRequest(bean).then(
      (res) => {
        if (res.success) {
          console.log('Saved!');
          this.activeModal.close(ModalResult.OK);
        } else {
          console.log('Error ' + res.description + ' ' + res.data);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );

  }

  onAccept(){
    const bean = new CustomMemoAggregation<MemoContentWorkShift>();
    bean.content = this.content;
    bean.memoAggregation = this.data;

    this.clientService.acceptAnApplicationToAWorkShiftRequest(bean).then(
      (res) => {
        if (res.success) {
          console.log('Saved!');
          this.activeModal.close(ModalResult.OK);
        } else {
          console.log('Error ' + res.description + ' ' + res.data);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );
  }




}
